export const HERO_URL = 'https://i.ibb.co/QndsyVn/hero.jpg';

export const ABOUT_IMG_URL = 'https://d1u4v6449fgzem.cloudfront.net/2020/03/The-Ecommerce-Business-Model-Explained.jpg';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';


export const CATEGORIES = [
    'all', 'desktop', 'laptop', 'printer', 'scanner', 'tablet', 'monitor'
];

export const BRANDS = [
    'All', 'Apple', 'Dell', 'HP', 'Samsung'
];